module.exports = __webpack_public_path__ + "img/product32-keliuyi.3181e016.svg";